"use client";
import { jsx as c, jsxs as k } from "react/jsx-runtime";
import t from "clsx";
import { memo as d, useMemo as f } from "react";
import h from "../../../hooks/useHorizonalScroll.js";
import { Box as i } from "../../base/Base.js";
import w from "next/image";
import '../../../assets/PickFace.css';const v = "_set_1gkdi_1", N = "__bottom_1gkdi_1", b = "_with_bg_1gkdi_5", x = "_wrapper_1gkdi_9", M = "_inner_1gkdi_20", y = "__center_1gkdi_26", F = "_pick_face_box_1gkdi_30", P = "__active_1gkdi_52", S = "_pick_face_1gkdi_30", j = "_status_1gkdi_62", A = "_error_1gkdi_71", I = "_icon_1gkdi_74", R = "_loading_1gkdi_78", z = "_rotation_1gkdi_1", B = "_add_pick_face_1gkdi_82", e = {
  set: v,
  _bottom: N,
  with_bg: b,
  wrapper: x,
  inner: M,
  _center: y,
  pick_face_box: F,
  _active: P,
  pick_face: S,
  status: j,
  error: A,
  icon: I,
  loading: R,
  rotation: z,
  add_pick_face: B
}, C = d(
  ({ bottom: r, theme: n = "none", center: o, children: a, ..._ }) => {
    const {
      wrapRef: s,
      innerRef: m,
      handlerChangeMask: l,
      onMouseStart: u,
      onMouseMove: g,
      onSwipeEnd: p
    } = h();
    return /* @__PURE__ */ c(
      i,
      {
        row: !0,
        wide: !0,
        className: t(e.set, e[n], {
          [e._bottom]: r
        }),
        ..._,
        children: /* @__PURE__ */ c(i, { row: !0, wide: !0, className: e.wrapper, ref: s, children: /* @__PURE__ */ c(
          i,
          {
            gap: 8,
            row: !0,
            className: t(e.inner, { [e._center]: o }),
            ref: m,
            onTouchMove: l,
            onWheel: l,
            onMouseDown: u,
            onMouseMove: g,
            onMouseUp: p,
            onMouseLeave: p,
            children: a
          }
        ) })
      }
    );
  }
);
C.displayName = "PickFaceSet";
const D = d(
  ({ image: r, active: n, status: o = "none", onClick: a, ..._ }) => {
    const s = f(() => {
      switch (o) {
        case "none":
          return null;
        case "ready":
          return "checkroom";
        case "tune":
          return "tune";
        case "loading":
          return "progress_activity";
        case "done":
          return "done";
        case "error":
          return "priority_high";
        default:
          return null;
      }
    }, [o]);
    return /* @__PURE__ */ k(
      "div",
      {
        className: t(e.pick_face_box, { [e._active]: n }),
        onClick: a,
        ..._,
        children: [
          /* @__PURE__ */ c(
            w,
            {
              src: r,
              alt: "face",
              width: 56,
              height: 56,
              className: e.pick_face
            }
          ),
          o !== "none" && /* @__PURE__ */ c("div", { className: t(e.status, e[o]), children: /* @__PURE__ */ c(
            "div",
            {
              className: t("material-icons", e.icon, e[o]),
              "data-icon": s
            }
          ) })
        ]
      }
    );
  }
);
D.displayName = "PickFace";
const E = d(
  ({ onClick: r, children: n, ...o }) => /* @__PURE__ */ k(i, { center: !0, className: e.add_pick_face, onClick: r, ...o, children: [
    /* @__PURE__ */ c("div", { className: "material-icons", "data-icon": "add" }),
    n
  ] })
);
E.displayName = "AddPickFace";
export {
  E as AddPickFace,
  D as PickFace,
  C as PickFaceSet
};
